/**
 * Handles string utilities.
 */
export default class StringUtility {
	/**
	 * Capitalizes first letter.
	 *
	 * @param text Text to use.
	 * @returns String with first letter capitalized.
	 */
	public static capitalizeFirstLetter(text: string): string {
		return text.charAt(0).toUpperCase() + text.slice(1);
	}

	/**
	 * Kebab case to words.
	 *
	 * @param string String to convert.
	 * @returns Text as kebab case.
	 */
	public static kebabToCamelCase(string): string {
		string = string.split('-');
		for (let i = 0, max = string.length; i < max; i++) {
			string[i] = this.capitalizeFirstLetter(string[i]);
		}
		return string.join('');
	}

	/**
	 * Function to change camel case to snake case.
	 *
	 * @param string
	 */
	public static camelToSnake(string: string): string {
		let result = '';

		// Loop through string.
		for (let i = 0; i < string.length; i++) {
			const ch = string.charAt(i);

			// Check if character is upper case and is not the first in index.
			// Append '_' and change character to lower case.
			if (ch === ch.toUpperCase()) {
				if (i > 0) {
					result = result + '_';
				}
				result = result + ch.toLowerCase();
			}

			// If the character is lower case then append to result string.
			else {
				result = result + ch;
			}
		}
		// Return the result
		return result;
	}

	/**
	 * Should remove spaces from both sides of string.
	 *
	 * @param text Text to use.
	 * @param [trim= ] Character to trim. Defaults to " ".
	 * @returns Converted string.
	 */
	public static trim(text: string, trim = ' '): string {
		while (text.length > 0 && text.charAt(0) === trim) {
			text = text.substring(1);
		}
		while (text.length > 0 && text.charAt(text.length - 1) === trim) {
			text = text.slice(0, -1);
		}
		return text;
	}
}
